import { __Enum } from './30pay';

export interface __Tokens {
    accessToken?: string;
    refreshToken?: string;
    tokenType?: string;
    expiresIn?: number;
    roles?: string[];
    isAuthorized?: boolean;
    fullName?: string;
    isTwoFactorEnabled?: boolean;
}

export enum __AuthStatus {
    valid = 'valid',
    pending = 'pending',
    inValid = 'inValid',
}

export interface __UserData {
    fullName?: string;
    fatherName?: string;
    nationalCode?: string;
    dateOfBirth?: string;
    phoneNumber: string;
    landline?: string;
    emailAddress?: string;
    level: {
        id: string;
        title: string;
        description: string;
        uniqueName: __Enum;
    };
    notifications: string[];
    logins?: string;
    twoFactor: {
        isActive: boolean;
        type: __Enum;
    };
    isVip?: boolean;
    id?: string;
}
